const listaDeCtrlStatus = (state) => {
    return state.items;
}

const loadingCtrlStatus = (state) => {
    return state.carregando
}

export {
    listaDeCtrlStatus,
    loadingCtrlStatus
}